export default {"src":"/_next/static/media/modern_mastercard.a1598535.svg","height":45,"width":44,"blurWidth":0,"blurHeight":0};